var $ = require('jquery');
require('slick-carousel');

var product = require('./product/index');

function init1774Slider() {
    const optionsPDP = {
        lazyLoad: 'ondemand',
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dotsClass: 'slider-dots',
        arrows: true,
        dots: true,
        prevArrow:
            '<div class="slick-prev link-1774"><i class="icon icon-1774-arrow-left-gallery" aria-hidden="true"></i></div>',
        nextArrow:
            '<div class="slick-next link-1774"><i class="icon icon-1774-arrow-right-gallery" aria-hidden="true"></i></div>'
    };

    $('.slick-product-description .carousel').slick(optionsPDP);
}

function init() {
    window.dwapp = window.dwapp || {};
    window.dwapp.reportRecommendationLoad = function () {
        var optionsPDPRecommendations = {
            lazyLoad: 'ondemand',
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            dotsClass: 'slider-dots',
            arrows: true,
            rtl: document.documentElement.lang === 'ar' ? true : false,
            dots: true,
            prevArrow: '<div class="slick-prev link-1774"><i class="icon icon-1774-arrow-left-gallery"></i></div>',
            nextArrow: '<div class="slick-next link-1774"><i class="icon icon-1774-arrow-right-gallery"></i></div>',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false
                    }
                }
            ]
        };

        $('.product-recommendations ul.slick-carousel').slick(optionsPDPRecommendations);
    };
    // init 1774 slider just if there is more than one image
    if ($('.slick-product-description ul.carousel .grid-tile').length > 1) {
        init1774Slider();
    }

    $('.main-image-arrows').addClass('link-1774');

    product.initializeEvents();
}

exports.init = init;
exports.init1774Slider = init1774Slider;
